export const Trauma = 
{
    Metadata:{Name:'Trauma',maxColumn:2,numRows:6},
    Sections:
    [
        {
            Headers:[
                "Have you experienced or witnessed any of the traumas listed below? Please check all appropriate boxes.",
                "Adult",
                "Child",
            ],
            Questions:[
                {
                    Prompt:"Sexual assault or trauma",
                    Responses:[
                        {Value:"adult",Type:"checkbox"},
                        {Value:"child",Type:"checkbox"},
                    ]
                },
                {
                    Prompt:"Physical violence, assault, or trauma",
                    Responses:[
                        {Value:"adult",Type:"checkbox"},
                        {Value:"child",Type:"checkbox"},
                    ]
                },
                {
                    Prompt:"Emotional abuse or trauma",
                    Responses:[
                        {Value:"adult",Type:"checkbox"},
                        {Value:"child",Type:"checkbox"},
                    ]
                },
                {
                    Prompt:"Have you witnessed a violent act",
                    Responses:[
                        {Value:"adult",Type:"checkbox"},
                        {Value:"child",Type:"checkbox"},
                    ]
                },
                {
                    Prompt:"Have you been in an accident where you or someone else suffered a significant injury",
                    Responses:[
                        {Value:"adult",Type:"checkbox"},
                        {Value:"child",Type:"checkbox"},
                    ]
                },
                {
                    Prompt:"Traumatic Brain Injury",
                    Responses:[
                        {Value:"adult",Type:"checkbox"},
                        {Value:"child",Type:"checkbox"},
                    ]
                },
            ]
        }
    ]
}